module.exports = __webpack_public_path__ + "img/lipin-footer.f4e29ac7.png";